import { Spin } from "antd";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import BasicLayout from "../layouts/BasicLayout";
import { useCurrentUser, useMe } from "../lib/hooks";
import routes from "../lib/routes";
import Dashboard from "../components/dashboard/Dashboard";
import Onboarding from "../components/onboarding";
import SiteProductTour from "../components/onboarding/ProductTour";
import { useInterval } from "react-use";
import { useRouter, useSearchParams } from "next/navigation";
import { SubscriptionPlans } from "../components/subscriptionPlans";
import { useEffect } from "react";
import Ticker from "../components/dashboard/Ticker";

const messages = defineMessages({
  pageTitle: { id: "dashboard.pageTitle", defaultMessage: "Dashboard" },
});

function CreatingSubscription() {
  const { refetch } = useMe();

  useInterval(() => {
    refetch();
  }, 5000);

  return (
    <div style={{ marginTop: "40vh", textAlign: "center" }}>
      <Spin description={<FormattedMessage id="user.signUp.creating" />} />
    </div>
  );
}

function UserOnboarding() {
  const router = useRouter();

  useEffect(() => {
    router.push(routes.welcome);
  }, []);

  return <Spin />;
}

function Home() {
  const intl = useIntl();
  const { forceTenantOnboarding, forceUserOnboarding, forceSubscription } =
    useCurrentUser();

  const searchParams = useSearchParams();

  const accountStateParam = searchParams.get("accountState");
  // this is flow for new accounts
  // old accounts should create farm manually, so they'll need to go thru onboarding flow
  const creatingSubcription =
    forceTenantOnboarding && accountStateParam === "creating";

  return (
    <BasicLayout
      title={intl.formatMessage(messages.pageTitle)}
      headerContent={
        !(forceTenantOnboarding || forceSubscription) && <Ticker />
      }
      contentStyle={{ background: "transparent", padding: "0px" }}
      ribbonTop={52}
    >
      {creatingSubcription ? (
        <CreatingSubscription />
      ) : forceUserOnboarding ? (
        <UserOnboarding />
      ) : forceSubscription ? (
        <SubscriptionPlans />
      ) : forceTenantOnboarding ? (
        <Onboarding />
      ) : (
        <>
          <SiteProductTour />
          <Dashboard />
        </>
      )}
    </BasicLayout>
  );
}

export default Home;
